import React, { useEffect } from 'react';
import Wrapper from './styles';
import { PageHero } from '../../components';
import aboutImg from '../../assets/hero1.jpeg';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'Diy World | About';
  }, []);

  return (
    <main>
      <PageHero title='about' />
      <Wrapper className='page section section-center'>
        <img src={aboutImg} alt='pic' />
        <article>
          <div className='title'>
            <h2>My Story</h2>
            <div className='underline'></div>
          </div>
          <p>
          Welcome to Diy World – your cozy haven of creativity where tradition blends seamlessly with contemporary design through the charm of crochet.
We specialize in unique, handcrafted woolen pieces that bring warmth, character, and beauty to everyday living. From stylish hair accessories to delicate crochet flower bouquets and delightful kitchen flowerpots, each creation is crafted with care, precision, and a deep love for wool artistry.

At Diy Worldcolors, we celebrate the magic of handmade craftsmanship — where every stitch tells its own story, and no two pieces are ever the same. Whether you’re in search of a heartfelt gift or a special treat for yourself, we’re here to add a touch of woolly wonder to your world.
          </p>
        </article>
      </Wrapper>
    </main>
  );
};

export default AboutPage;
